import React, {useContext, useEffect, useState} from 'react';
import MapComponent from '../../widget/MapComponent';
import { useDispatch, useSelector } from 'react-redux';

import {
	fetchActualLandUses,
	fetchCadastralMunicipalities,
	fetchDedicatedLandUses,
	fetchIllegalWasteDumpsPageForMap,
	fetchMunicipalities,
	fetchOwnershipTypes,
} from '../../../state/api/illegalWasteDumpsAPI';
import { useTranslation } from 'react-i18next';
import wasteDumpTypes from '../../../model/wasteDumpTypes';
import { useFilter } from '../../../hooks/filterHook';
import Filter from '../../widget/Filter';
import { fetchWasteCategoriesList } from '../../../state/api/wasteCategoriesAPI';
import { PlotContext } from '../../../context/PlotContext';
import {setMapFilter} from "../../../state/filter/filterValues";
import _ from "lodash";

const Map = () => {
	const { t } = useTranslation();
	const wasteDumpOptions = wasteDumpTypes();
	const dispatch = useDispatch();
	const list = useSelector((state) => state.illegalWasteDumpsAPI.mapList);
	const { setPlot } = useContext(PlotContext);

	const initialFilterFromStore = useSelector((state) => state.filterValues.mapFilter);
	const [initialFilter, setInitialFilter] = useState(null);

	const {zoom: initialZoom} = useSelector((state) => state.mapCoordinates);

	const fetchData = (page, filter, sort) => {
		dispatch(fetchIllegalWasteDumpsPageForMap({filter: filter}));
	};


	const { onFilter, filter } = useFilter(
		{},
		() => {},
		fetchData
	);


	useEffect(() => {
		setPlot(null);

		if(_.isEmpty(initialFilterFromStore)) {
			return;
		}
		const timer = setTimeout(() => {
			setInitialFilter(initialFilterFromStore);
		}, 500);

		return () => clearTimeout(timer);
	}, []);

	return (
		<div className="map-page">
			<Filter
				columns={[
					{
						id: 'status',
						type: 'select',
						name: t('status'),
						options: wasteDumpOptions,
					},
					{
						name: t('municipality'),
						type: 'inputtag',
						id: 'municipality.name',
						selector: [(state) => state.illegalWasteDumpsAPI.municipalities],
						fetchAction: [fetchMunicipalities],
						valueType: 'object',
					},
					{
						name: t('cadastral_municipality'),
						type: 'inputtag',
						id: 'cadastralMunicipality.name',
						selector: [
							(state) => state.illegalWasteDumpsAPI.cadastralMunicipalities,
						],
						fetchAction: [fetchCadastralMunicipalities],
						valueType: 'object',
					},
					{
						name: t('waste_type'),
						type: 'inputtag',
						id: 'wasteTypes.type.nameInternal',
						selector: [(state) => state.wasteCategoriesAPI.categories],
						fetchAction: [fetchWasteCategoriesList],
						valueType: 'object',
						filter: 'EQ',
						filterKey: 'code',
						displayKey: 'name',
						searchKey: 'nameInternal',
					},
					{
						id: 'insertAt',
						type: 'date',
						name: 'insert_at',
					},
					{
						name: t('ownership_type'),
						type: 'inputtag',
						id: 'ownershipTypes.name',
						selector: [(state) => state.illegalWasteDumpsAPI.ownershipTypes],
						fetchAction: [fetchOwnershipTypes],
						valueType: 'object',
					},
					{
						name: t('actual_land_use'),
						type: 'inputtag',
						id: 'actualLandUses.name',
						selector: [(state) => state.illegalWasteDumpsAPI.actualLandUses],
						fetchAction: [fetchActualLandUses],
						valueType: 'object',
					},
					{
						name: t('dedicated_land_use'),
						type: 'inputtag',
						id: 'dedicatedLandUses.name',
						selector: [(state) => state.illegalWasteDumpsAPI.dedicatedLandUses],
						fetchAction: [fetchDedicatedLandUses],
						valueType: 'object',
					},
				]}
				filter={filter}
				initialFilter={initialFilter}
				onFilter={(filter, formValues) => {
					onFilter(filter);
					dispatch(setMapFilter(formValues));
				}}
			/>
			<MapComponent markers={list} redirect={true} initialZoom={initialZoom}/>
		</div>
	);
};

export default Map;
